import {EntryCard} from "@client/components/EntryCard";
import {getFilteredFoodsAsCalculatableEntries} from "@client/features/foods";
import {TextInput} from "@client/forms";
import * as router from "@client/router";
import * as React from "react";

export const FoodList = router.FoodList.withHooks((props) => {
    const [filter, setFilter] = React.useState("");

    return {
        foods: getFilteredFoodsAsCalculatableEntries(filter, props.resolved.food_list),
        filter,
        setFilter,
    };
})
    .withIndex((props) => (
        <>
            {props.foods.map((entry, index) => (
                <EntryCard
                    key={index}
                    link={router.locator({
                        route: "update_food.macros",
                        params: {foodId: entry.food_id},
                        resolved: props.resolved,
                    })}
                    entry={entry}
                    hiddenMacros={props.profile.has_hidden_macros}
                />
            ))}
        </>
    ))
    .withActions(() => [
        {
            icon: "plus",
            title: "Create",
            link: router.locator({route: "create_food.macros", params: {}}),
        },
    ])
    .withOptions((props) => ({
        title: "My Foods",
        scene: {kind: "SIMPLE"},
        topSection: (
            <div>
                <TextInput
                    name=""
                    flush
                    readOnly={false}
                    placeholder="Filter foods"
                    onChange={props.setFilter}
                    value={props.filter}
                />
            </div>
        ),
    }));
